import shuffle from 'lodash/shuffle';

export const getReversedArray = ( length ) => {
	let array = [];
	for (var i = 0; i < length; i++) { 
		array[i] = length - i; 
	}
	return array;
}

export const getNormalizedArray = ( array ) => {
	// normalize values in array, 
	// e.g. turning [1, 5, 2, 8] into [1, 3, 2, 4]
	const sorted = array.concat().sort( (a, b) => a - b );
	return array ? array.map( value => sorted.indexOf(value)+1 ) : null;
}

export const setIndexToHighest = ( orders, index ) => {
	const topOrder = Math.max( ...orders );
	const thisOrder = orders[ index ];
	if ( thisOrder === topOrder ) {
		return orders;
	} else {
		let newOrders = orders.concat();
		newOrders[index] = (topOrder + 1);
		return getNormalizedArray( newOrders );
	}
}

export const getListOfRotations = (length, step) => {
	const fixedSequence = [0, -1, 3];
	const listLength = Math.max((length*2+1), 7);
	let indexes = [];
	for (var i = 0; i < listLength; i++) indexes.push( (i - (listLength-1)/2) ); 
	let shuffled = shuffle( indexes );
	shuffled = shuffled.filter( val => (fixedSequence.indexOf(val)===-1) );
	shuffled = fixedSequence.concat( shuffled );
	const angles = shuffled.map( val => val * step )
	return angles;
}


// WEBPACK FOOTER //
// ./src/components/Pages/Project/Chunks/Stacks/utils.jsx